// eslint-disable-next-line
import { injectable } from "inversify";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";

export interface IMerchantVideo {
    id: number,
    section_id: number,
    name: string,
    link: string,
    weight: number,
    is_enabled: number,
}

export enum MERCHANT_VIDEO_SECTIONS {
    DASHBOARD = 1,
    STORE_SETTINGS = 2,
    RESOLUTION_SETTINGS = 3,
    POLICY_RULE_SETTINGS = 4,
    INTEGRATION_SETTINGS = 5,
    RETURN_METHOD_SETTINGS = 6,
    LOCALIZATION_SETTINGS = 7,
    RETURNS_PAGE = 8,
    ANALYTICS_PAGE = 9,
}

@injectable()
class MerchantVideoService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async loadVideosOfSection(sectionID: MERCHANT_VIDEO_SECTIONS): Promise<IMerchantVideo[]> {
        const res = await this.httpService.get<IApiResponse<IMerchantVideo[]>>(`/rms-api/merchant-videos/${sectionID}`);
        return res.payload;
    }
}

export default MerchantVideoService;
